import Button from "@common/components/Button";
import Dialog from "@common/components/Dialog";
import DialogActions from "@common/components/Dialog/DialogActions";
import DialogTitle from "@common/components/Dialog/DialogTitle";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import { DialogContent, DialogContentText } from "@mui/material";
import { stopMeeting } from "@services/meetings";
import React from "react";
import { useTranslation } from "react-i18next";

type ConfirmTerminateDialogProps = {
  open: boolean;
  onConfirm: Function;
};

const ConfirmTerminateDialog = (props: ConfirmTerminateDialogProps) => {
  const { open, onConfirm } = props;
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();

  const { t } = useTranslation();

  const confirmStopMeeting = async () => {
    try {
      await stopMeeting(context.detail?.meeting?.id);
      context.detail?.refetch();
      onConfirm(true);
    } catch (e) {
      dispatchError(e);
    }
  };

  return (
    <Dialog open={open} onClose={() => onConfirm(false)}>
      <DialogTitle>{t("Terminate Meeting")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("Are you sure you want to terminate this meeting?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="greyed"
          onClick={() => onConfirm(false)}
        >
          Cancel
        </Button>
        <Button color="error" onClick={() => confirmStopMeeting()}>
          Terminate Meeting
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmTerminateDialog;
